import * as React from "react";
import type { SVGProps } from "react";
const SvgOpenNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#23F6E7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.333 2.5H17.5v4.167M11.667 8.333 17.5 2.5M15.833 11.668v4.167c0 .92-.745 1.666-1.666 1.666h-10c-.921 0-1.667-.745-1.667-1.666v-10c0-.921.746-1.667 1.667-1.667h4.166"
    />
  </svg>
);
export default SvgOpenNew;
